import {
  alertStyle,
  entitySelectorStyle,
  paginationStyle,
} from '@bingads-webui-campaign-react/common-styles';

export const getDisclaimerSettingsStyles = ({ palette, iconFontFamily = 'MsAds MDL2 Assets' }) => (
  {
    display: 'flex',
    flexDirection: 'column',

    '& .form-group': {
      '& .glyphicon': {
        fontFamily: iconFontFamily,
      },

      '& .form-control-static': {
        marginTop: 8,
        marginBottom: 8,
        position: 'relative',

        '& .addDisclaimerButton': {
          position: 'absolute',
          left: 0,
        },
      },

      '& .alert.alert-info': {
        marginTop: 5,
        marginBottom: 16,
        width: 'fit-content',
      },

      '& .disclaimer-selector': {
        '& .list-selector-option': {
          '& .disclaimer-item-name': {
            display: 'inline-block',
            maxWidth: 180,
          },

          '& .action-right': {
            float: 'right',
          },
        },

        '& .open .dropdown-menu': {
          position: 'relative',
          marginBottom: 10,

          '& .list-selector-content': {
            height: 'auto',
          },
        },

        '& .truncated': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      },

      ...entitySelectorStyle({ palette, iconFontFamily }),
      ...paginationStyle({ palette }),
    },

    '& .col-sm-1, & .col-sm-2, & .col-sm-3, & .col-sm-4, & .col-sm-5, & .col-sm-6, & .col-sm-7, & .col-sm-8, & .col-sm-9, & .col-sm-10, & .col-sm-11, & .col-sm-12': {
      float: 'none',
      paddingLeft: 0,
      paddingRight: 0,
    },
  }
);

export const getDisclaimerPanelStyles = ({ palette, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '.disclaimer-editor-panel': {
    ...alertStyle({ palette, iconFontFamily }),

    '& .panel-content': {
      width: 592,

      '& .panel-title': {
        fontSize: 20,
        fontWeight: '600 !important',
        lineHeight: '27px',
      },

      '& .panel-body': {
        paddingRight: 64,
        display: 'flex',
        'flex-direction': 'column',

        '& .disclaimer-setting-content': {
          marginBottom: 'auto',
        },

        '& .disclaimer-setting-footer': {
          marginTop: 32,

          '& button ~ button': {
            marginLeft: 10,
          },
        },
      },

      '& .form-group': {
        margin: 0,

        '& > .control-label': {
          textAlign: 'left',
          float: 'none',
          width: '100%',
        },

        '& > .col-sm-8': {
          width: '100%',
        },
      },

      '& .form-group ~ .form-group': {
        marginTop: 32,
      },

      '& .col-sm-1, & .col-sm-2, & .col-sm-3, & .col-sm-4, & .col-sm-5, & .col-sm-6, & .col-sm-7, & .col-sm-8, & .col-sm-9, & .col-sm-10, & .col-sm-11, & .col-sm-12': {
        float: 'none',
        paddingLeft: 0,
        paddingRight: 0,
      },

      '& .alert.alert-info': {
        marginTop: 8,
      },

      '& div.error': {
        color: '#A80000',
        margin: '4px 0 0 0',
        fontSize: 12,
      },

      '& .mt-error': {
        backgroundColor: '#fde7e9',
        padding: 5,
        marginTop: 10,
        '& .over-all-errors.error': {
          fontSize: 12,
          color: '#D90026',
        },
      },

      '& .setting-disclaimer-layoutType .radio': {
        paddingTop: 0,
      },

      '& .dropdown-toggle.btn': {
        border: 'none',
        width: '100%',
        height: '100%',
        paddingLeft: 8,
        paddingRight: 8,
        borderRadius: 2,

        '& span': {
          marginTop: 'auto',
          marginBottom: 'auto',
        },
      },

      '& .ba-dropdown-selector': {
        position: 'relative',
        border: `1px solid ${palette.neutralSecondary}`,
        minWidth: 132,
        verticalAlign: 'baseline',
        height: 30,
        borderRadius: 2,

        '& .glyphicon': {
          fontFamily: iconFontFamily,
        },

        '& .glyphicon-triangle-bottom': {
          marginTop: 4,
          '&::before': {
            content: '"\\E70D"',
          },
        },
      },

      '& .dropdown-menu': {
        top: 'auto',
        position: 'absolute',
        width: '100%',
        padding: '10px',
      },

      '& .ba-list-selector': {
        border: 'none',
        '& .list-selector-item': {
          padding: '5px 10px',
          margin: '0',
          '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#f5f5f5',
          },
          '&.selected': {
            background: '#E7F0F6',
          },
          '& .item-actions': {
            float: 'right',
          },
        },
      },

      '& textarea#disclaimer-editor-information-popup': {
        height: 169,
        resize: 'none',
      },

      '& textarea#disclaimer-editor-information-additionalline': {
        height: 69,
        resize: 'none',
      },

      '& .url-editor-form': {
        display: 'flex',
        gridTemplateColumns: 'auto 1fr',

        '& > select.form-control': {
          width: 'auto',
          marginRight: 6,
        },

        '& > input': {
          marginLeft: 6,
        },
      },
    },
  },
});
